import React from 'react'

import './editUserProfileImage.css'

const EditUserProfileImage = ({id, userProfileData}: any) => {
  return (
    <div>EditUserProfileImage</div>
  )
}

export default EditUserProfileImage